import React, { useRef, useState, useEffect } from 'react';
import '../anima/Onboarding/src/screens/Onboarding/style.css';
import '../anima/Onboarding/styleguide.css';
import { CmpPrimarybutton } from '../components/cmp/CmpPrimarybutton';
import { useRouter } from 'expo-router';
import { setUserStorage, getCurrentUserId } from '../utils/userStorage';
import { storage } from '../services/storage';
import { Platform } from 'react-native';


const Onboarding: React.FC = () => {
  const [canContinue, setCanContinue] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  const handleScroll = () => {
    const el = scrollRef.current;
    if (el) {
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
      console.log('📝 Onboarding scroll check:', {
        scrollTop: el.scrollTop,
        clientHeight: el.clientHeight,
        scrollHeight: el.scrollHeight,
        atBottom,
        calculation: `${el.scrollTop} + ${el.clientHeight} >= ${el.scrollHeight - 2}`,
        canContinueWas: canContinue,
        canContinueWillBe: atBottom
      });
      
      if (atBottom && !canContinue) {
        console.log('✅ Onboarding - enabling continue button');
        setCanContinue(true);
      }
    }
  };

  // Check initial scroll state when component mounts
  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      console.log('🔍 Initial onboarding scroll state:', {
        scrollTop: el.scrollTop,
        clientHeight: el.clientHeight,
        scrollHeight: el.scrollHeight,
        atBottom: el.scrollTop + el.clientHeight >= el.scrollHeight - 2,
        viewportHeight: Platform.OS === 'web' ? window.innerHeight : 'N/A',
        containerComputedHeight: Platform.OS === 'web' ? window.getComputedStyle(el).height : 'N/A'
      });
      
      // If content is already scrollable, trigger initial check
      if (el.scrollHeight > el.clientHeight) {
        handleScroll();
      } else {
        // If there's no scrollable content (all fits), auto-enable continue
        console.log('⚠️ Onboarding content fits entirely - auto-enabling continue');
        setCanContinue(true);
      }
    }
  }, []);

  // Add debugging on component mount
  useEffect(() => {
    (async () => {
      const currentTestUser = Platform.OS === 'web' ? sessionStorage.getItem('currentTestUser') : await storage.getItem('currentTestUser');
      const userId = await getCurrentUserId();
      console.log('🎭 Onboarding component mounted:', {
        sessionStorage: currentTestUser,
        currentUserId: userId,
        url: Platform.OS === 'web' ? window.location.href : 'N/A',
        allSessionKeys: Platform.OS === 'web' ? Object.keys(sessionStorage) : []
      });
    })();
  }, []);

  const handleContinue = async () => {
    if (canContinue) {
      console.log('➡️ Onboarding continue clicked - going to legal');
      
      // Get the actual user ID from sessionStorage (for test users) or fallback to getCurrentUserId
      const sessionTestUser = Platform.OS === 'web' ? sessionStorage.getItem('currentTestUser') : await storage.getItem('currentTestUser');
      const userId = sessionTestUser || await getCurrentUserId();
      
      console.log('📝 Setting onboarding seen flag:', {
        sessionTestUser,
        userId,
        storageKey: `${userId}_cedar_onboarding_seen`
      });
      
      // Set flag to indicate user has seen onboarding
      await setUserStorage('cedar_onboarding_seen', 'true', userId);
      router.push('/legal');
    }
  };

  return (
    <div className="onboarding onboarding-container" data-model-id="2288:5496">
      <div className="frame">
        <p className="welcome-to-the-coach">
          From the<br />Coach Cedar Team
        </p>
      </div>
      <div
        className="hey-there-thanks-for-wrapper"
        ref={scrollRef}
        onScroll={handleScroll}
        style={{ cursor: canContinue ? 'pointer' : 'default' }}
      >
        <div className="hey-there-thanks-for">
          <div style={{ marginBottom: 16 }}>
            You're here because something about your health and fitness matters to you — a race on the calendar, getting back into a routine, pushing past a plateau, managing around an injury, or just wanting to feel better and move more.
          </div>
          
          <div style={{ marginBottom: 16 }}>
            What you'll find with Cedar is different from what's out there. It's not a workout library. It's not a static plan. It's a coaching relationship — one that learns how you train, adjusts when life changes, and gets better the longer you use it.
          </div>
          
          <div style={{ marginBottom: 16 }}>
            Cedar builds your plan on real sports science. It stays close between workouts. And when you don't have a perfect setup or a full hour, it meets you where you are.
          </div>
          
          <div style={{ marginBottom: 16 }}>
            You're one of the first people to try this. We can't tell you exactly where the coaching relationship will take you — that's between you and Cedar — but what happens over the coming weeks will surprise you.
          </div>
          
          <div style={{ marginBottom: 16 }}>
            Welcome. We're excited for you.
          </div>
          
          <div>
            <b>— The Coach Cedar Team</b>
          </div>
        </div>
      </div>
      

      
      <div
        className="cmp-primarybutton-instance"
        style={{ opacity: canContinue ? 1 : 0.5, pointerEvents: canContinue ? 'auto' : 'none' }}
        onClick={handleContinue}
      >
        <CmpPrimarybutton state="default" />
      </div>
    </div>
  );
};

export default Onboarding; 